import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.search";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '@/services/apiService';
import { mapState } from 'vuex';
import { localizeDate, userItemsPerListMixin } from '@/utils/vuex';
import isEqual from 'lodash/isEqual';
import debounce from 'lodash/debounce';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['createdAt'],
  sortDesc: [true],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'CoreBackgroundJobsTable',
  mixins: [userItemsPerListMixin],
  props: {
    accounts: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    searchTypes: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    predefinedSearch: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    // if used in the device-type list, do not restore the last filter from the virtual-device-list
    // should show ALL unfiltered devices by default
    restoreFilter: {
      type: Boolean,
      required: false,
      default: function _default() {
        return true;
      }
    },
    containerClass: {
      type: String,
      default: function _default() {
        return 'n20-mainrow';
      },
      required: false
    },
    jobType: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      deletePrompt: false,
      cancelPromptCsvImport: false,
      cancelPromptBulkEdit: false,
      disableFetchOnCreatedMixin: true,
      lastSearch: null,
      searchItems: [],
      isFetching: false,
      tableOptions: defaultTableOptions,
      selected: [],
      list: [],
      serverItemsLength: null,
      selectedItem: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'permissions'])), {}, {
    isEmptyList: function isEmptyList() {
      return this.searchItems.length === 0 && this.serverItemsLength <= 0 && this.isFetching === false;
    },
    tableHeaders: function tableHeaders() {
      return [{
        text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.id'),
        value: 'id',
        align: 'center',
        sortable: false
      }, {
        text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.title'),
        value: 'title',
        align: 'start',
        sortable: false
      }, {
        text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.devicesNumber'),
        value: 'tasks',
        align: 'start',
        sortable: false
      }, {
        text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.state'),
        value: 'state',
        align: 'start',
        sortable: false
      }, {
        text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.errors'),
        value: 'tasks.errors',
        align: 'start',
        sortable: false
      }, {
        text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.createdAt'),
        value: 'createdAt'
      }, {
        text: this.$i18n_t('BackgroundJobs.BackgroundJobs.table.user'),
        value: 'userCreated',
        align: 'start',
        sortable: false
      }].concat(_toConsumableArray(this.hasReadPermissions ? [{
        align: 'end',
        sortable: false,
        value: 'actions'
      }] : []));
    },
    tableFooterProps: function tableFooterProps() {
      return {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      };
    },
    accountsIds: function accountsIds() {
      return this.accounts.map(function (acc) {
        return acc.id;
      });
    },
    hasReadPermissions: function hasReadPermissions() {
      switch (this.jobType) {
        case 'virtualDevicesEdit':
        case 'virtualDevicesCsvImport':
          return this.permissions['VirtualDevice.read'];

        case 'digitalTwinBulkDuplicate':
          return this.permissions['DigitalTwin.read'];
      }

      return this.permissions['VirtualDevice.read'] || this.permissions['DigitalTwin.read'];
    },
    canDeleteItem: function canDeleteItem() {
      if (this.permissions['all.manage']) {
        return true;
      }

      switch (this.jobType) {
        case 'virtualDevicesEdit':
        case 'virtualDevicesCsvImport':
          return this.permissions['VirtualDevice.manage'];

        case 'digitalTwinBulkDuplicate':
          return this.permissions['DigitalTwin.manage'];
      }

      return this.permissions['VirtualDevice.manage'] || this.permissions['DigitalTwin.manage'];
    }
  }),
  watch: {
    accounts: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }

      this.fetchList();
    }, 500),
    tableOptions: {
      handler: function handler() {
        this.fetchList();
      },
      deep: true
    }
  },
  created: function created() {
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
    this.fetchList(true);
  },
  methods: {
    fetchList: function fetchList() {
      var _this = this;

      var fromStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      var searchItems = (this.predefinedSearch || []).concat(this.searchItems).map(function (item) {
        return {
          variable: item.param,
          // support item.search.value === null, so do not simply have a >search.value || search< expression
          search: (item.search || {}).value === undefined ? item.search : item.search.value,
          key: item.key
        };
      });

      if (!isEqual(this.lastSearch, JSON.stringify(searchItems))) {
        this.lastSearch = JSON.stringify(searchItems);
        this.tableOptions = _objectSpread(_objectSpread({}, this.tableOptions), {}, {
          page: 1
        });
      }

      var tableOptions = fromStart ? _objectSpread(_objectSpread({}, this.tableOptions), {}, {
        page: 1
      }) : this.tableOptions;
      var sortBy = tableOptions.sortBy,
          sortDesc = tableOptions.sortDesc,
          page = tableOptions.page,
          itemsPerPage = tableOptions.itemsPerPage;
      sortBy = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      var usedPage = Math.max(1, page || 1);
      var limit = itemsPerPage || defaultItemsPerPage;
      var offset = (usedPage - 1) * limit;
      ApiService.fetchBackgroundJobByAccountIds(this.accountsIds, sortBy, doSortDesc, limit, offset, this.jobType).then(function (result) {
        _this.list = result.data;

        if (searchItems.length) {
          _this.tableOptions.itemsPerPage = 10;
        }

        _this.serverItemsLength = result.pagination.itemCount;

        _this.$emit('load-items', result);
      }).catch(function (error) {
        console.error('Error fetching virtual devices', error);
      }).finally(function () {
        _this.isFetching = false;
      });
    },
    searchUpdated: function searchUpdated(search) {
      this.searchItems = search;
      this.fetchList(true);
      this.$emit('search-updated', this.searchItems);
    },
    deletePromise: function deletePromise() {
      return ApiService.deleteBackgroundRunner(this.selectedItem.id);
    },
    handleClickRunner: function handleClickRunner(item) {
      this.$emit('show-item-info', item);
    },
    localizeDate: localizeDate,
    showDeletePrompt: function showDeletePrompt(item) {
      this.selectedItem = item;
      this.deletePrompt = true;
    },
    showCancelPrompt: function showCancelPrompt(item) {
      this.selectedItem = item;
      item.type === 'virtualDevicesCsvImport' || item.type === 'digitalTwinBulkDuplicate' ? this.cancelPromptCsvImport = true : item.type === 'virtualDevicesEdit' ? this.cancelPromptBulkEdit = true : null;
    },
    cancelRunner: function cancelRunner() {
      var _this2 = this;

      this.cancelPromptCsvImport = false;
      this.cancelPromptBulkEdit = false;
      ApiService.cancelBackgroundRunner(this.selectedItem.id).then(function () {
        _this2.$snack(_this2.$i18n_t('BackgroundJobs.BackgroundJobs.snacks.cancelSuccess'), 'success');

        _this2.fetchList();
      }).catch(function (error) {
        if (error.response && _this2.$i18n_t("Error.".concat(error.response.data.message))) {
          _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this2.$snack(_this2.$i18n_t('BackgroundJobs.BackgroundJobs.snacks.cancelFailed'), 'error');
        }
      });
    },
    deleteItem: function deleteItem() {
      var _this3 = this;

      this.deletePrompt = false;
      this.deletePromise().then(function () {
        _this3.$snack(_this3.$i18n_t('BackgroundJobs.BackgroundJobs.snacks.deleteSuccess'), 'success');

        _this3.fetchList();
      }).catch(function (error) {
        console.error(_this3.$i18n_t('BackgroundJobs.BackgroundJobs.snacks.deleteFailed'), error);

        if (error.response && _this3.$i18n_t("Error.".concat(error.response.data.message))) {
          _this3.$snack(_this3.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this3.$snack(_this3.$i18n_t('BackgroundJobs.BackgroundJobs.snacks.deleteFailed'), 'error');
        }
      });
    }
  }
};